export default __webpack_public_path__ + "static/media/совы_DoV (12) 1.25d90523.png";